import { IInTakeSurveyPoll, IInTakeSurveyQuestionMeta } from '../builders/ap_intake_survey_builder';

import * as _4 from 'lodash4';
import { IntakeSurveyApiQuesAnswerStrategy } from '../strategies/intake_survey_api_ques_ans_strategy';
import { QuestionTypeInputTypeStrategy } from '../strategies/question_type_input_type_strategy';
export class PollServant {
  static isRadioTypeQuestion(question: IInTakeSurveyQuestionMeta): boolean {
    return QuestionTypeInputTypeStrategy[question.question_type] === 'radio';
  }

  static isCheckboxTypeQuestion(question: IInTakeSurveyQuestionMeta): boolean {
    return QuestionTypeInputTypeStrategy[question.question_type] === 'checkbox';
  }

  static hasEveryQuestionAnswered(questions: IInTakeSurveyQuestionMeta[]): boolean {
    return (
      questions.length ===
      questions.filter((question: IInTakeSurveyQuestionMeta) => !_4.isEmpty(question._answer)).length
    );
  }

  static getQuestionAndAnswerMappedForApi(questions: IInTakeSurveyQuestionMeta[]) {
    const mappedQandAns = {};
    questions.forEach((question) => {
      mappedQandAns[question.id] = IntakeSurveyApiQuesAnswerStrategy[_4.get(question, '_question_type', '')](question);
    });
    return mappedQandAns;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/servants/poll_servant.ts